export default __webpack_public_path__ + "static/media/visual.f78df487.jpg";